import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'labels' });

export const { find, reducer } = actions;

export default reducer;
